"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _glamor = require("glamor");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _DownloadIcon = _interopRequireDefault(require("./Assets/DownloadIcon"));

var _ScreenReaderText = _interopRequireDefault(require("../ScreenReaderText"));

var _useByteFormatter = _interopRequireDefault(require("../hooks/useByteFormatter"));

var _useDirection3 = _interopRequireDefault(require("../hooks/useDirection"));

var _useLocalizer = _interopRequireDefault(require("../hooks/useLocalizer"));

var _useStyleSet3 = _interopRequireDefault(require("../hooks/useStyleSet"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ROOT_CSS = (0, _glamor.css)({
  display: 'flex',
  '& .webchat__fileContent__buttonLink': {
    display: 'flex',
    flex: 1
  },
  '& .webchat__fileContent__badge': {
    display: 'flex',
    flex: 1,
    flexDirection: 'column'
  }
});

var FileContentBadge = function FileContentBadge(_ref) {
  var downloadIcon = _ref.downloadIcon,
      fileName = _ref.fileName,
      size = _ref.size;

  var _useDirection = (0, _useDirection3.default)(),
      _useDirection2 = _slicedToArray(_useDirection, 1),
      direction = _useDirection2[0];

  var formatByte = (0, _useByteFormatter.default)();
  var localizedSize = typeof size === 'number' && formatByte(size);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
    "aria-hidden": true,
    className: "webchat__fileContent__badge"
  }, _react.default.createElement("div", {
    className: "webchat__fileContent__fileName"
  }, fileName), !!localizedSize && _react.default.createElement("div", {
    className: "webchat__fileContent__size"
  }, localizedSize)), downloadIcon && _react.default.createElement(_DownloadIcon.default, {
    className: (0, _classnames.default)('webchat__fileContent__downloadIcon', direction === 'rtl' && 'webchat__fileContent__downloadIcon--rtl'),
    size: 1.5
  }));
};

FileContentBadge.defaultProps = {
  downloadIcon: false,
  size: undefined
};
FileContentBadge.propTypes = {
  downloadIcon: _propTypes.default.bool,
  fileName: _propTypes.default.string.isRequired,
  size: _propTypes.default.number
};

var FileContent = function FileContent(_ref2) {
  var className = _ref2.className,
      href = _ref2.href,
      fileName = _ref2.fileName,
      size = _ref2.size;

  var _useStyleSet = (0, _useStyleSet3.default)(),
      _useStyleSet2 = _slicedToArray(_useStyleSet, 1),
      fileContentStyleSet = _useStyleSet2[0].fileContent;

  var localize = (0, _useLocalizer.default)();
  var localizeBytes = (0, _useByteFormatter.default)();
  var localizedSize = typeof size === 'number' && localizeBytes(size);
  var alt = localize(href ? localizedSize ? 'FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT' : 'FILE_CONTENT_DOWNLOADABLE_ALT' : localizedSize ? 'FILE_CONTENT_WITH_SIZE_ALT' : 'FILE_CONTENT_ALT', fileName, localizedSize);
  return _react.default.createElement("div", {
    "aria-hidden": true,
    className: (0, _classnames.default)('webchat__fileContent', ROOT_CSS + '', fileContentStyleSet + '', (className || '') + '')
  }, _react.default.createElement(_ScreenReaderText.default, {
    text: alt
  }), href ? _react.default.createElement("a", {
    "aria-hidden": true,
    className: "webchat__fileContent__buttonLink",
    download: fileName,
    href: href,
    rel: "noopener noreferrer",
    target: "_blank"
  }, _react.default.createElement(FileContentBadge, {
    downloadIcon: true,
    fileName: fileName,
    size: size
  })) : _react.default.createElement(FileContentBadge, {
    downloadIcon: false,
    fileName: fileName,
    size: size
  }));
};

FileContent.defaultProps = {
  className: '',
  href: undefined,
  size: undefined
};
FileContent.propTypes = {
  className: _propTypes.default.string,
  fileName: _propTypes.default.string.isRequired,
  href: _propTypes.default.string,
  size: _propTypes.default.number
};
var _default = FileContent;
exports.default = _default;